// @flow
import React from 'react'
import { Box } from 'frack-components'
import { Container } from '@siteone/atoms'

type Props = {
  bgColor?: string,
  /* full width of page, not using container max width */
  fluid?: boolean,
}

const Section = ({
  children, fluid, ...props
}: Props) => (
  <Box {...props}>
    <Container fluid={fluid}>
      {children}
    </Container>
  </Box>
)

Section.defaultProps = {
  tag: 'section',
  bgColor: 'white',
  paddingVertical: 6,
  fluid: false,
}

export default Section
